import { Store } from 'src/store/index';

const getPriceFormat = (store: Store) => store.price.priceFormat;

export default getPriceFormat;
